import { Button } from "@/v2-components/ui/button";
import StoreLineIcon from "@/v2-components/core/icon/store-line-icon";
import { useTrans } from "@/utils/useTrans";
import { cn } from "@/libs/utils";
import React from "react";

/**
 * 재고 있을 때의 리테일러 진입 — **40px 원형 아이콘 버튼** (시안 29116:30970 맨 왼쪽).
 *
 * `RetailerSheet` 의 `trigger` 로 넘긴다. `SheetTrigger asChild` 가 `ref` 와 `onClick` 을
 * 주입하므로 **forwardRef 로 받아 넘겨야** 한다 — 안 넘기면 시트가 열리지 않는다.
 *
 * 스타일은 `TactSuitCard.NotifyOrAddToBag` 의 `iconOnly` 분기와 **같은 값**을 쓴다:
 * 테두리 `Cool Gray/20` · 아이콘 `Cool Gray/90` · hover 는 옆 결제 버튼과 같은
 * `blue-outline`(`bg-blue-60` + 흰 내용). 아이콘이 `currentColor` 라 hover 에서 함께 흰색이
 * 된다 — 그 성질에 의존하므로 아이콘 색을 하드코딩하면 안 된다.
 */
export const RetailerIconButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof Button>
>(function RetailerIconButton({ className, ...props }, ref) {
  const { t } = useTrans(["tactsuit"]);
  // 라벨이 없으므로 접근 이름을 남긴다 — 아이콘만 있는 버튼은 스크린리더가 "버튼" 으로만 읽는다.
  const label = t("Find a retailer");

  return (
    <Button
      ref={ref}
      size="square-sm"
      shape="pill"
      variant="blue-outline"
      aria-label={label}
      title={label}
      className={cn(
        "shrink-0 px-0 text-coolgray-90 outline-coolgray-20",
        className,
      )}
      {...props}
    >
      <StoreLineIcon />
    </Button>
  );
});
